import { ArrowButton, Dropdown, Alert } from '@plurall/elo'
import React, { useEffect, useState } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { Client } from 'utils'

import styles from './QuestionForm.module.scss'

const client = new Client()

const QuestionForm = ({ location }) => {
  const [disciplines, setDisciplines] = useState([])
  const [disciplinesIds, setDisciplinesIds] = useState([])
  const [redirect, setRedirect] = useState()

  const { message, status } = queryString.parse(location.search)

  useEffect(() => {
    async function loadDisciplines() {
      let disciplinesList = await client.getDisciplines()

      disciplinesList = disciplinesList.map(discipline => ({
        id: discipline.id,
        value: discipline.name,
      }))

      setDisciplines(disciplinesList)
    }
    loadDisciplines()

    if (location.search) {
      const params = queryString.parse(location.search)
      if (params.question) {
        const question = JSON.parse(params.question)

        setDisciplinesIds(question.disciplinesIds)
      }
    }
  }, [location.search])

  let questionValues = {
    difficulty: '',
    discipline: '',
    tags: '',
    number: '',
    question_kind: '',
  }

  if (location.search) {
    const params = queryString.parse(location.search)
    if (params.question) {
      const question = JSON.parse(params.question)
      questionValues = {
        difficulty: question.difficulty,
        discipline: question.discipline,
        tags: question.tags,
        number: question.number,
        question_kind: question.question_kind,
      }
    }
  }

  function handleChange(value) {
    if (value.length === 0) {
      setError('discipline', {
        message: 'O campo "Disciplina" é obrigatório.',
      })
    } else {
      clearErrors('discipline')
    }
    setDisciplinesIds(value)
  }

  function onSubmitForm(dataSubmit) {
    if (!disciplinesIds.length) {
      setError('discipline', {
        message: 'O campo "Disciplina" é obrigatório.',
      })
    } else {
      const question = { ...dataSubmit, disciplinesIds }
      Object.keys(question).forEach(key => question[key] === '' && delete question[key])

      const redirectTo = `/create/question?question=${JSON.stringify(question)}`

      setRedirect(redirectTo)
    }
  }

  const { register, handleSubmit, formState: { errors, isValid }, setError, clearErrors } = useForm({
    mode: 'onChange',
    defaultValues: {
      difficulty: questionValues.difficulty,
      discipline: questionValues.discipline,
      tags: questionValues.tags,
      number: questionValues.number,
      question_kind: questionValues.question_kind,
    },
  })

  const difficulty = [
    { id: '', name: 'Selecione' },
    { id: 'easy', name: 'Fácil' },
    { id: 'medium', name: 'Médio' },
    { id: 'difficult', name: 'Difícil' },
  ]

  const types = [
    { id: '', name: 'Selecione' },
    { id: 'open_response', name: 'Discursiva' },
    { id: 'open_response_subitem', name: 'Dissertativa com subitens' },
    { id: 'multiple_choice', name: 'Múltipla escolha' },
    { id: 'objective', name: 'Objetiva' },
  ]
  return (
    <div>
      <div className={styles.header}>
        <Link to='/'>
          <ArrowButton direction='left' />
        </Link>
        <h1 className={styles.heading}>Criar questão</h1>
      </div>
      {message && <Alert type={status}>{message}</Alert>}
      <form onSubmit={handleSubmit(onSubmitForm)} className={styles['question-form']}>
        <div>
          <label className={styles.name}>
            Disciplinas <label className={styles.red}>*</label>
          </label>
          <div className={styles.dropdown}>
            <Dropdown
              items={disciplines}
              disabled={disciplines.length === 0}
              placeholder='Selecione'
              selected={disciplinesIds}
              onChange={handleChange}
              multiselect
              buttonLabel={{ singular: 'disciplina', plural: 'disciplinas' }}
            />
          </div>
          {errors.discipline && <p className={styles.error}>{errors.discipline.message}</p>}
        </div>

        <label className={styles.name}>Nível de dificuldade</label>
        <select value={difficulty.id} {...register('difficulty')}>
          {difficulty.map(item => (
            <option value={item.id} key={item.name}>
              {item.name}
            </option>
          ))}
        </select>

        <label className={styles.name}>Tags</label>
        <input type='text' className={styles['input-form']} {...register('tags')} />
        <p className={styles.error}>Separe tags diferentes com , (vírgula).</p>

        <label className={styles.name}>
          Número da questão <label className={styles.red}>*</label>
        </label>
        <input
          type='text'
          className={`${styles['number-question']} ${styles['input-form']}`}
          {...register('number', {
            required: {
              value: true,
              message: 'O campo "Número da questão" é obrigatório.',
            },
          })}
        />
        {errors.number && <p className={styles.error}>{errors.number.message}</p>}
        <label className={styles.name}>
          Formato da questão <label className={styles.red}>*</label>
        </label>
        <select
          value={types.id}
          {...register('question_kind', {
            required: 'O campo "Formato da questão" é obrigatório.',
          })}
        >
          {types.map(item => (
            <option value={item.id} key={item.name}>
              {item.name}
            </option>
          ))}
        </select>
        {errors.question_kind && <p className={styles.error}>{errors.question_kind.message}</p>}
        <input
          className={styles.button}
          type='submit'
          value='Avançar'
          disabled={!isValid || !disciplinesIds.length}
        />
      </form>
      {redirect && <Redirect to={redirect} />}
    </div>
  )
}
QuestionForm.propTypes = {
  location: PropTypes.object,
}

export default QuestionForm
